import React from 'react';
import './CoinflipSkeleton.css';

const CoinflipSkeleton: React.FC = () => {
  return (
    <div className="coinflip-page">
      {/* Header Section - Matching coinflip-header */}
      <div className="coinflip-header skeleton-header">
        <div className="coinflip-header-left">
          <div className="game-info">
            <div className="skeleton-title"></div>
            <div className="skeleton-subtitle"></div>
          </div>
        </div>
        
        <div className="coinflip-header-right">
          <div className="skeleton-bet-label"></div>
          <div className="bet-controls">
            <div className="skeleton-input-wrapper"></div>
            <div className="skeleton-quick-btn"></div>
            <div className="skeleton-quick-btn"></div>
            <div className="coin-choices">
              <div className="skeleton-coin-choice"></div>
              <div className="skeleton-coin-choice"></div>
            </div>
            <div className="skeleton-create-btn"></div>
          </div>
        </div>
      </div>

      {/* Games Section - Matching games-section */}
      <div className="games-section">
        {/* Info Header - Matching games-info-header */}
        <div className="games-info-header skeleton-info-header">
          <div className="left-section">
            <div className="skeleton-games-count"></div>
          </div>
          <div className="right-section">
            <div className="filters">
              <div className="skeleton-dropdown"></div>
              <div className="skeleton-dropdown"></div>
            </div>
          </div>
        </div>

        {/* Games List - Matching games-list */}
        <div className="games-list">
          {[...Array(2)].map((_, index) => (
            <div key={index} className="game-item skeleton-game-item">
              {/* Left Player - Matching player-section */}
              <div className="player-section left-player">
                <div className="player-avatar-container skeleton-avatar-wrapper">
                  <div className="skeleton-player-avatar"></div>
                  <div className="skeleton-choice-indicator"></div>
                </div>
                <div className="skeleton-player-name"></div>
              </div>

              {/* VS Divider - Matching vs-divider */}
              <div className="vs-divider skeleton-vs">VS</div>

              {/* Right Player - Matching player-section */}
              <div className="player-section right-player">
                <div className="player-avatar-container skeleton-avatar-wrapper waiting">
                  <div className="skeleton-player-avatar"></div>
                  <div className="skeleton-choice-indicator"></div>
                </div>
                <div className="skeleton-player-name"></div>
              </div>

              {/* Game Actions - Matching game-actions */}
              <div className="game-actions skeleton-actions">
                <div className="skeleton-amount-display"></div>
                <div className="skeleton-join-btn"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoinflipSkeleton;
